import { CardType } from './payments';
export const iFrameAnalyticsEvents = ['credit-card.actions.post-page-error'];
export const INSTANT_CHECKOUT_OVERLAY = 'instant-checkout-page-modify-overlay';
export const INSTANT_CHECKOUT_POST_PAGE_ERROR = 'instant-checkout-post-page-error';
export const INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK = 'instant-checkout-continue-shopping';
export const PHA_PAGE_LOAD_ERROR = 'pro-house-account.actions.page-load-error';
export const cardTypePageSectionMapping = {
    [CardType.CREDIT_CARD]: 'cards and accounts page',
    [CardType.GIFT_CARD]: 'cards and accounts page',
    [CardType.CHECKING_ACCOUNT]: 'cards and accounts page',
    [CardType.KEY_TAG]: 'cards and accounts page',
    [CardType.PRO_XTRA_DOLLARS]: 'cards and accounts page',
    [CardType.PAYPAL_ACCOUNT]: 'cards and accounts page',
    [CardType.PRO_HOUSE_ACCOUNT]: 'pro house account',
};
export const HD_WALLET_POST_PAGE_ERROR = 'home-depot-wallet.post-page-error';
export const CREDIT_CARD_POST_PAGE_ERROR = 'credit-card.actions.post-page-error';
export const CREDIT_CARD_HD_WALLET_BUTTON_CLICK = 'credit-card.actions.hdwallet-button-click';
export const HD_WALLET_BUTTON_CLICK = 'home-depot-wallet.actions.button-click';
export const AUTHORIZE_CARD_REMOTE_PURCHASES = 'authorize-card-remote-purchases';
export const AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK = 'authorize-card-remote-purchases.button-submission';
